export default __webpack_public_path__ + "static/media/uploader-empty-state.04dcabc7.png";